import type { ValidationIssue } from '../../../../Model/Order/ValidationIssue.js'
import { isReverseFileAttachRefused } from '../../../../Model/Order/ValidationIssue.js'

/** The backend's reason for refusing the attach, or a fallback that still says what to do. */
export const describeAttachRefusal = (error: unknown): string => {
  const body = (error as { response?: unknown } | null)?.response
  const reasons = Array.isArray(body) ? (body as ValidationIssue[]).filter(isReverseFileAttachRefused).map((issue) => issue.issue) : []
  if (reasons.length > 0) {
    return reasons.join('\n')
  }
  if ((error as { status?: number } | null)?.status === 409) {
    return 'The sample was changed in the meantime. Reload the page and try again.'
  }
  return 'The R2 file could not be added to the sample. Reload the page and try again.'
}
